// extracted by mini-css-extract-plugin
export default {"pricingContainer":"PricingPage_pricingContainer__vJm78","card":"PricingPage_card__5Scoh"};